// extracted by mini-css-extract-plugin
export default {"risk-level__icon-container":"style_risk-level__icon-container__LCeCk","risk-level__text":"style_risk-level__text__5OqIN"};